import debounce from 'lodash.debounce';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import apiService from '../../../features/api/service';
// import service from '../../../event-form/service';
import { fetchEvent } from '../../../features/event/slice';
import TestimonialFormDumb from '../../../features/program-form-v1/components/sections/testimonial/testimonial-form-dumb';
import { blobToFile, errorHandler } from '../../../utils';

const TestimonialForm = ({data, withImage = false, onUpdated}) => {
  const isEdit = data
  const dispatch = useDispatch()
  const [requesting, setRequesting] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [form, setForm] = useState({})
  const { id: eventId } = useSelector(state => state.event.data)

  useEffect(() => {
    if(data){
      setForm(data)
    }
  }, [data])

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      setForm({
        ...form,
        [key]: value
      })
    }
  }, 250)

  const handleImage = (file) => {
    if (file) {
      const blob = URL.createObjectURL(file)
      console.log(file, blob)

      setForm({
        ...form,
        image: blob,
        _image: {
          name: file.name,
          type: file.type,
          blob
        }
      })
    }
  }

  const handleSave = async () => {
    console.log(form)

    const handleCreate = () => {
      const requestBody = {
        "testimoniNonUser": {
          "nama": form.name,
          "deskripsi": form.description
        }
      }

      console.log({requestBody})

      // service.updateProgramDirect(eventId, requestBody)
      //   .then(res => {
      //     toast.success('Successfully added.')
      //     dispatch(fetchEvent(eventId))
      //   })
      //   .catch(err => {
      //     const msg = errorHandler(err)
      //     setErrorMessage(msg)
      //   })
      //   .finally(() => setRequesting(false))
    }

    const handleUpdate = async () => {
      if(form.id){
        let promise1, promise2

        const requestBody = {
          "nama": form.name,
          "deskripsi": form.description
        }
        console.log(requestBody)
        promise1 = apiService.update('testimoni_external', form.id, requestBody)

        if(form.image && form._image){
          const requestBody2 = new FormData()
          const {blob, name, type} = form._image
          const file = await blobToFile(blob, name, type)
          if(file){
            console.log({file})
            requestBody2.append('imgFoto', file)
            promise2 = apiService.update('testimoni_external', form.id, requestBody2)
          }
        }

        Promise.all([promise1, promise2])
          .then(res => {
            toast.success('Successfully updated.')
            dispatch(fetchEvent(eventId))
            onUpdated()
          })
          .catch(err => {
            const msg = errorHandler(err)
            setErrorMessage(msg)
          })
          .finally(() => setRequesting(false))
      }
    }

    if(eventId){
      setRequesting(true)
      setErrorMessage(null)

      if(isEdit){
        handleUpdate()
      } else {
        handleCreate()
      }
    }
  }

  return <TestimonialFormDumb
    form={form}
    handleInput={handleInput}
    handleImage={handleImage}
    errorMessage={errorMessage}
    setErrorMessage={setErrorMessage}
    handleSave={handleSave}
    requesting={requesting}
    withImage={withImage}
  />
}

export default TestimonialForm
